export default {
  gift_card_removed: 'Gavekort fjernet',
  invalid_gift_card: 'Gavekortet er ugyldigt',
  gift_card_applied: 'Gavekort anvendt',
};
